import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { EmailAccessModal } from '../../data-rooms/components/data-room-drawer/EmailAccessModal'
import { useIntl } from 'react-intl'
import { PasscodeAccessModal } from '../../data-rooms/components/data-room-drawer/PasscodeAccessModal'
import {
  createAccess,
  getRecordPublicShareLink,
  updateFileVersionDownloadCount,
} from '../core/_requests'
import { toast } from 'react-toastify'
import Downloadicon from '../../../../media/billing/ic-download.svg'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import { getLocation } from '../../onboarding/core/_requests'
import { RecordKeeperContentView } from '../components/RecordsAndFiles/RecordKeeperContentView'
import Skeleton from 'react-loading-skeleton'
import { useThemeMode } from '../../../../_metronic/partials'
import brandingConfig from '../../../../config/brandingConfig'

const RecordKeeperPreview = () => {
  const location = useLocation()
  const { mode } = useThemeMode()
  const pathname = location.pathname
  const parts = pathname.split('/')
  const paramValue = parts[parts.length - 1]
  const { formatMessage } = useIntl()
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false)
  const [showPasscodeModal, setShowPasscodeModal] = useState<boolean>(false)
  const [isEnteringEmail, setIsEnteringEmail] = useState<boolean>(false)
  const [isEnteringPasscode, setIsEnteringPasscode] = useState<boolean>(false)
  const [passwordErr, setPasswordErr] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [passcode, setPasscode] = useState<string>('')
  const [isDownloadable, setIsDownloadable] = useState<boolean>(false)
  const [emailIdErr, setEmailIdErr] = useState<boolean>(false)
  const [contentName, setContentName] = useState<string>('')
  const [fileName, setFileName] = useState('')
  const [signedUrl, setSignedUrl] = useState('')
  const [recordId, setRecordId] = useState<string>('')
  const [city, setCity] = useState('')
  const [ipAddress, setIpAddress] = useState('')
  const [deviceType, setDeviceType] = useState('')
  const [osType, setOsType] = useState('')
  const [fileType, setFileType] = useState('')
  const [fileVersionId, setFileVersionId] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }
  const getRecordPublicByShareLink = async (uuid: string, passcode: string, email: string) => {
    try {
      if (email) {
        setIsEnteringEmail(true)
      }
      if (email && passcode) {
        setIsEnteringPasscode(true)
      }
      setLoading(true)
      const {
        data: { data, success, errors },
      } = await getRecordPublicShareLink(uuid, passcode, email)
      if (success) {
        setShowEmailModal(false)
        setFileType(data?.content?.recordKeeperFileVersion?.fileType)
        setContentName(data?.content?.recordKeeperFileVersion?.name.split('/').pop())
        setFileVersionId(data?.content?.recordKeeperFileVersion?.fileVersionId)
        setIsDownloadable(data?.allowDownload ? data?.allowDownload : false)
        setSignedUrl(data?.signedUrl)
        setRecordId(data?.content?.recordId)
        setFileName(data?.content?.recordKeeperFileVersion?.name)
        if (showPasscodeModal) {
          setShowPasscodeModal(false)
          setIsEnteringPasscode(false)
        }
        if (showEmailModal) {
          setShowEmailModal(false)
          setIsEnteringEmail(false)
        }
      } else {
        errors.forEach((error: string) => {
          if (error === 'EMAIL_REQUIRED') {
            setShowEmailModal(true)
            setShowPasscodeModal(false)
          } else if (error === 'PASSCODE_REQUIRED') {
            setShowEmailModal(false)
            setIsEnteringEmail(false)
            setShowPasscodeModal(true)
          }
          else if (error === "Share link is not active") {
            toast.error(error)
          }
          else {
            if (error === 'PASSCODE_INVALID')
              toast.error('Invalid Passcode, Please Enter A Valid Passcode')
            setIsEnteringEmail(false)
            setIsEnteringPasscode(false)
          }

        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      createAccessLog()
      setLoading(false)
    }
  }
  useEffect(() => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const find = async () => {
      try {
        const locationApiData = await getLocation()
        setCity(locationApiData?.data.country)
        setIpAddress(locationApiData?.data?.ip)
      } catch {
        setCity('')
        setIpAddress('')
      }
    }
    setDeviceType(deviceTypeView)
    setOsType(os)
    find()
  }, [])
  useEffect(() => {
    getRecordPublicByShareLink(paramValue, passcode, email)
  }, []) // eslint-disable-line

  const onDownloadFile = async () => {
    if (!fileVersionId) return
    try {
      const {
        data: { success },
      } = await updateFileVersionDownloadCount(fileVersionId)
      if (success) {
        const a = document.createElement('a')
        a.href = signedUrl
        a.download = 'download'
        document.body.appendChild(a)
        a.click()
        a.remove() // This line is sufficient to remove the element from the DOM
        toast.success(formatMessage({ id: 'File downloaded successfully' }))
      } else {
        toast.error(formatMessage({ id: 'File download failed' }))
      }
    } catch (error) {
      console.error(error)
    }
  }

  const createAccessLog = async () => {
    try {
      if (deviceType && osType && city && recordId) {
        const {
          data: { success, errors },
        } = await createAccess(recordId, osType, deviceType, city, ipAddress, 'UNAUTHORIZED')
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  console.log('signedUrl', signedUrl);

  return (
    <>
      {loading ?
        <Skeleton width='100vw' height='100vh' className='m-5' />
        :
        fileName && (
          <>
            <div className='vh-100'>
              <div className='mx-4 py-1 border-bottom'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: "center",
                  height: '8vh'
                }}
              >
                <img
                  src={mode === 'dark' ? brandingConfig.darkModeLogo : brandingConfig.lightModeLogo}
                  alt={formatMessage({ id: 'recordskeeper.ai-Logo' })}
                />

                <div className='d-flex gap-1'>
                  {isDownloadable && (
                    <p className='cursor-pointer mb-0' onClick={() => onDownloadFile()}>
                      <img
                        src={Downloadicon}
                        height={30}
                        width={30}
                        alt={formatMessage({ id: 'download-icon' })}
                        style={{ filter: 'grayscale(100%)' }}
                      />
                    </p>
                  )}
                  <p className='mt-2 mb-0'>
                    <ToolTipUI tooltipText={`File name : ${contentName}`} />
                  </p>
                </div>
              </div>
              <div
                style={{
                  height: '1px',
                  backgroundColor: 'rgba(0, 0, 0, 0.1)',
                  margin: '0 1rem',
                }}
              ></div>
              <RecordKeeperContentView
                signURL={signedUrl}
                fileName={fileName}
                extension={fileType}
                customClassNames='w-100 h-100'
              />
            </div>

          </>
        )
      }
      <EmailAccessModal
        setAccessModal={setShowEmailModal}
        accessModal={showEmailModal}
        accessLoading={isEnteringEmail}
        email={email}
        AccessId={paramValue}
        onAccess={getRecordPublicByShareLink}
        setEmail={setEmail}
        heading={formatMessage({ id: 'Enter your email id to access this file' })}
        labelText={formatMessage({ id: 'Email Address' })}
        emailIdErr={emailIdErr}
        setEmailIdErr={setEmailIdErr}
      />
      <PasscodeAccessModal
        setAccessModal={setShowPasscodeModal}
        accessModal={showPasscodeModal}
        onAccess={getRecordPublicByShareLink}
        accessLoading={isEnteringPasscode}
        AccessId={paramValue}
        passcode={passcode}
        setPasscode={setPasscode}
        email={email}
        heading={formatMessage({ id: 'Enter password to access the file' })}
        labelText={formatMessage({ id: 'Enter Passcode' })}
        passwordErr={passwordErr}
        setPasswordErr={setPasswordErr}
      />
    </>
  )
}

export default RecordKeeperPreview
